import { getcause } from "@/server/api";
import { loadFuture, loadOverdue } from "@/server/loan";
import { debtorExpire } from "@/server/debtor";
import { bankList } from "@/server/directory"
const state = {
  data: {},
  list: [],
  bankList: [], 
};
const mutations = {
  SET_DATA: (state, data) => {
    state.data = data; 
  },
  SET_LIST: (state, data) => {
    state.list = data;
  },
  SET_BANK_LIST(state, data) {
    state.bankList = data;
  }
};
const actions = {
  async getlist({ commit, state, dispatch }, data) {
    await dispatch("potData", data);
    return await new Promise((resolve, reject) => {
      getcause(state.data).then((e) => {
        //获取案件详情信息，并返回
        dispatch("setList", e.list);
        resolve(e.list);
      });
    });
  },
  async getBanklist({ commit, state }) {
    if (state.bankList.length > 0) {
      return state.bankList;
    }
    try {
      const res = await bankList({ limit: 500 });
      const list = res.list || [];
      commit('SET_BANK_LIST', list); // 存入 Vuex
      return list;
    } catch (err) {
      console.error("获取银行列表失败", err);
      return [];
    }
  },
  putInData({ commit, state, dispatch }, { index, key, value } = data) {
    let list = JSON.parse(JSON.stringify(state.list));
    list[index][key] = value;
    dispatch("setList", list);
  },
  potData({ commit }, data) {
    commit("SET_DATA", data);
  },
  setList({ commit }, data) {
    commit("SET_LIST", data);
  },
  getloadFuture({ commit }, data) {
    //即将履行
    return new Promise((resolve, reject) => {
      loadFuture(data).then((e) => {
        resolve(e);
      });
    });
  },
  getloadOverdue({ commit }, data) {
    //逾期列表
    return new Promise((resolve, reject) => {
      loadOverdue(data).then((e) => {
        resolve(e);
      });
    });
  },
  getdebtorExpire({ commit }, data) {
    //保全列表
    return new Promise((resolve, reject) => {
      debtorExpire(data).then((e) => {
        resolve(e);
      });
    });
  },
};
const getters = {
  bankList: (state) => state.bankList
};
export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
